<template>
  <div class="events-keeper">
    <transition-group
      class="events-keeper__wrapper"
      name="event-list"
      tag="div"
    >
      <div
        v-for="(message, index) in eventsList"
        :key="message"
        class="events-keeper__message"
        :class="{'events-keeper__message_loading': message?.status === 'loading'}"
        @click="closeMessage(index)"
      >
        <icon-close class="events-keeper__close-button"/>
        <div v-show="message?.label" class="events-keeper__message-label">
          <icon-success-check v-if="message?.status === 'success'" class="events-keeper__message-status-icon" />
          <icon-error-check v-else-if="message?.status === 'error'" class="events-keeper__message-status-icon" />
          <div v-else-if="message?.status === 'loading'" class="events-keeper__loading">
            <div class="events-keeper__loader-spinner"/>
          </div>
          <template v-if="typeof message?.label === 'string'">
            {{ message?.label }}
          </template>
          <template v-else>
            <component :is="message?.label"></component>
          </template>
        </div>
        <div 
        v-if="message?.message && message?.onMessageClick" 
        :class="['events-keeper__message-text events-keeper__message-clickable', message?.status ? 'is-icon' : '']"
        @click.stop="message?.onMessageClick()"
        >
          {{ message?.message }}
        </div>
        <div v-else-if="message?.message" :class="['events-keeper__message-text', message?.status ? 'is-icon' : '']">
          {{ message?.message }}
        </div>
      </div>
    </transition-group>
  </div>
</template>

<script setup>
import { ref, inject } from "vue";
import IconClose from "@/components/ui/icons/IconClose.vue";
import IconSuccessCheck from "@/components/ui/icons/IconSuccessCheck.vue";
import IconErrorCheck from "@/components/ui/icons/IconErrorCheck.vue";

const $emitter = inject("emitter")
const eventsList = ref([])

$emitter.on("addEvent", (message) => {
  let timeout = message?.timeout ?? 5000
  eventsList.value.push(message)
  if(timeout !== 0){
    setTimeout(() => {
    eventsList.value.splice(0, 1);
    }, timeout)
  }
})

function closeMessage(index) {
  if (index > -1) {
    eventsList.value.splice(index, 1);
  }
}
</script>

<style lang="scss" scoped>
.events-keeper {
  position: fixed;
  z-index: 22;
  top: 80px;
  right: 32px;
  display: flex;
  flex-direction: column;

  @include screenM {
    top: 70px;
    bottom: unset;
    left: 24px;
    right: 24px;
  }

  &__message-status-icon {
    margin: 0 12px 0 0;
  }

  &__wrapper {
    position: relative;
    display: flex;
    flex-direction: column;
    margin: 0;

    @include screenM {
      align-items: flex-end;
      width: calc(100vw - 48px);
    }
  }
  &__close-button {
    position: absolute;
    top: 16px;
    right: 16px;
    width: 24px;
    height: 24px;
    cursor: pointer;
    color: var(--font-color-two);
  }

  &__message {
    position: relative;
    width: 400px;
    padding: 16px 32px 16px 16px;
    border-radius: 8px;
    background-color: #FFF;
    box-shadow: 0 25px 55px -10px #08113133;

    @include screenM {
      max-width: 312px;
    }

    &:not(:first-child) {
      margin: 8px 0 0 0;
    }
  }
  &__message-title {
    font-size: 14px;
    font-weight: 600;

    @include screenM {
      font-size: 12px;
    }
  }
  &__message-label {
    font-size: 14px;
    line-height: 20px;
    font-weight: 500;
    display: flex;
    align-items: center;
  }

  &__message-text {
    font-size: 14px;
    line-height: 20px;
    margin: 8px 0 0 0;
    color: var(--font-color-secondary);

    @include screenM {
      margin: 4px 0 0 0;
    }

    &.is-icon {
      margin: 8px 0 0 36px;

      @include screenM {
        margin: 4px 0 0 36px;
      }
    }
  }

  &__message-clickable {
    color: var(--primary-color);
    cursor: pointer;
  }

  &__loading {
    margin-right: 16px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  &__loader-spinner {
    width: 20px;
    height: 20px;
    border: 2px solid var(--primary-color);
    border-radius: 50%;
    border-right-color: transparent;
    animation: .7s linear infinite spinner-border;

    @keyframes spinner-border {
      to {
        transform: rotate(360deg) #{"/* rtl:ignore */"};
      }
    }
  }
}

@keyframes spinner-border {
    to {
      transform: rotate(360deg);
    }
}

.event-list-move,
.event-list-enter-active,
.event-list-leave-active {
  transition: all 0.5s ease;
}

.event-list-enter-from,
.event-list-leave-to {
  transform: translateX(30px);
  opacity: 0;
}
</style>
